import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {

  constructor(
    private spinner: NgxSpinnerService,
    private toastr: ToastrService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const skipPrefix = req.headers.has('Skip-API-Prefix');
    let apiReq = req;

    if (!skipPrefix) {
      const apiUrl = environment.API_URL.replace(/\/+$/, '');
      const reqUrl = req.url.replace(/^\/+/, '');
      const token = localStorage.getItem('token');
      const headersConfig: any = {};

      if (token) {
        headersConfig['Authorization'] = `Bearer ${token}`;
      }

      apiReq = req.clone({
        url: `${apiUrl}/${reqUrl}`,
        setHeaders: headersConfig
      });
    }

    this.spinner.show();

    return next.handle(apiReq).pipe(
      catchError((error: HttpErrorResponse) => {
        let errorMessage = 'An unknown error occurred!';
        if (error.error instanceof ErrorEvent) {
          errorMessage = `Error: ${error.error.message}`;
        } else {
          errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        // this.toastr.error(errorMessage, 'Error');
        return throwError(() => error);
      }),
      finalize(() => {
        this.spinner.hide();
      })
    );
  }
} 